const Speakers = [
    {
        "name": "LAKEHAL Ahmed Amine",
        "occupation": "Founder's Associate at Starfounders(France)",
        "description": "Motion Design and Visual elements in a Business context",
        "img": "./data/profileImg/ahmad.png"
    },
    {
        "name": "BENMAHIEDDINE Houssem",
        "occupation": "Graphic Brand,Ui/UX Designer,& Digital content creator",
        "description": "Building a successful brand",
        "img": "./data/profileImg/houssem.png"
    },
    {
        "name": "MERZOUG Islem",
        "occupation": "Fullstack web-dev and Web/Salesforce",
        "description": "Salesforce: the global leader CRM",
        "img": "./data/profileImg/merzoug.png"
    }, {
        "name": "IZOUNTAR Abderrahim",
        "occupation": "Graphic designer, web developer, entrepreneur",
        "description": "The requirement for your business promotion",
        "img": "./data/profileImg/izountar.png"
    }, {
        "name": "RAHIM Samy",
        "occupation": "",
        "description": "Graphic and UI/UX designer cs student at ESTIN",
        "img": "./data/profileImg/samy.png"
    }, {
        "name": "KHENFOUF Ayoub",
        "occupation": "",
        "description": "Graphic and UI/UX designer cs student at ESI Alger",
        "img": "./data/profileImg/ayoub.png"
    }, {
        "name": "OUAL Mohamed Anis",
        "occupation": "",
        "description": "Graphic designer Digital content creater at Gossradio",
        "img": "./data/profileImg/anis.png"
    }

]
export default Speakers